"use client"

import IframeResizer from "@iframe-resizer/react"
import clsx from "clsx"
import React from "react"

import PageGrid from "@/ui/components/PageGrid"
import SectionWrapper from "@/ui/components/SectionWrapper"

const NewsletterSubscribeForm: React.FC = (
  props: React.ComponentPropsWithoutRef<"section">,
) => {
  const { className, ...restOfProps } = props

  return (
    <SectionWrapper className={clsx("bg-gray-2.5", className)} {...restOfProps}>
      <PageGrid className="p-8 md:py-12 bg-gray-5 gap-y-4 md:gap-y-8 lg:gap-y-10 xl:gap-y-12">
        <h2 className="col-span-full md:col-span-2 lg:col-span-6 lg:headline4 md:headline5 heading1 blue-gradient-bds">
          Subscribe to the Ripple newsletter for more insights and updates.
        </h2>
        <div className="col-span-full md:col-span-2 lg:col-span-6">
          <IframeResizer
            src="https://go.ripple.com/l/105572/2025-07-02/qvv5fq"
            className="w-full"
            license="GPLv3"
          />
        </div>
      </PageGrid>
    </SectionWrapper>
  )
}

export default NewsletterSubscribeForm
